export const data = [{
    title: "Pilates Studio",
    description: "A full-stack web app for a pilates studio with user authentication, a members-only video library, and a booking system.",
    skills: ["React", "Firebase", "Firestore"],
    imageSrc: require("../assets/pilates-thumb.png"),
    // vidSrc: require("../assets/pilates.mp4"),
    source: ""
  },
  {
    title: "Psychology Portfolio",
    description: "A clean, responsive portfolio website for a psychologist showcasing their practice, approach, and services.",
    skills: ["React", "CSS"],
    imageSrc: require("../assets/psychology-thumb.png"),
    // vidSrc: require("../assets/psychology2.mov"),
    source: ""
  },

{
    "title": "Martabanii - Small Business Website",
    "imageSrc": require("../assets/martabanii.png"),
    // "vidSrc": require("../assets/digits.mov"),
    "description": "A product showcase website for a homemade jam brand. Built with React, TypeScript, and Tailwind CSS and deployed on Netlify.",
    "skills":[ "React", "Typescript", "Tailwind"],
    "liveUrl": "https://martabanii.com"
    // "source": "https://github.com/Fawazak/fawazak.github.io/blob/main/ELEC_A2%20(2)%20(1).ipynb"
},
{
    title: "Personal Portfolio",
  description: "A fully custom portfolio site built from scratch with a dark glassmorphism aesthetic, light/dark mode, smooth CSS animations, and a contact form.",
  skills: ["React", "CSS", "EmailJS"],
  imageSrc: require("../assets/portfolio-thumb.png"),
//   vidSrc: require("../assets/portfolio.mp4"),
  source: "https://github.com/Fawazak/WebApp"
}];

export default data;